import { render } from "./StudentPayment.vue?vue&type=template&id=28be4af1"
import script from "./StudentPayment.vue?vue&type=script&lang=js"
export * from "./StudentPayment.vue?vue&type=script&lang=js"

import "./StudentPayment.vue?vue&type=style&index=0&id=28be4af1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__